import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GET_ALL_CONFIGS } from "../../../../services/ApiCalls";



const PricingRow = ({ index, register, control, setValue, remove, canRemove, pricingData, errors,pctypes,ptypes }) => {
    const { t } = useTranslation();
    const basePrice = useWatch({
        control,
        name: `pricingData.${index}.basePrice`,
    });

    const discount = useWatch({
        control,
        name: `pricingData.${index}.discount`,
    });

    const pricingType = useWatch({
        control,
        name: `pricingData.${index}.pricingType`,
    });
     const pricingCategory = useWatch({
        control,
        name: `pricingData.${index}.priceCategory`,
    });

    useEffect(() => {
        const base = Number(basePrice) || 0;
        const disc = Number(discount) || 0;

        const final = base - (base * disc) / 100;

        setValue(
            `pricingData.${index}.finalPrice`,
            final > 0 ? Math.round(final) : 0,
            { shouldDirty: true }
        );
    }, [basePrice, discount, index, setValue]);



    return (
        <div className="border rounded p-3 mb-3 ">
            <Row>
                <Col lg="3">
                    <label> {t("roomType.columns.pricingType")}</label>

                    <Form.Select {...register(`pricingData.${index}.pricingType`)}>
                        {/* <option value={""}>{"Select"}</option> */}
                        {
                            ptypes.map((val)=><option value={val}>{val}</option>)
                        }
                       
                    </Form.Select>
                </Col>
                <Col lg="3">
                    <label> {t("roomType.columns.pricingCategory","Pricing Category")}</label>
                    <Form.Select {...register(`pricingData.${index}.priceCategory`)}>
                        {
                            pctypes.map((val)=><option value={val}>{val}</option>)
                        }
                       
                    </Form.Select>
                </Col>
                  {pricingCategory === "special" && (
                    <Col lg="3">
                        <label>{t("roomType.columns.startDate","Start Date")}</label>
                        <input
                        type="date"
                            className={`form-control `}
                            {...register(`pricingData.${index}.startDate`)}
                        />
                        {errors?.pricingData && errors?.pricingData[index]?.startDate && (
                            <p className="text-danger mt-2">
                                {errors?.pricingData[index]?.startDate?.message}
                            </p>
                        )}
                    </Col>
                )}
                {pricingCategory === "special" && (
                    <Col lg="3">
                        <label>{t("roomType.columns.endDate","End Date")}</label>
                        <input
                                                type="date"

                            className={`form-control `}
                            {...register(`pricingData.${index}.endDate`)}
                        />
                        {errors?.pricingData && errors?.pricingData[index]?.endDate && (
                            <p className="text-danger mt-2">
                                {errors?.pricingData[index]?.endDate?.message}
                            </p>
                        )}
                    </Col>
                )}

                {pricingType === "hour" && (
                    <Col lg="3">
                        <label>{t("roomType.columns.durationHours")}</label>
                        <input
                            className={`form-control ${isDuplicateValue({
                                pricingData,
                                index,
                                pricingType,
                                fieldName: "durationHours",
                            })
                                ? "border-danger"
                                : ""
                                }`}
                            {...register(`pricingData.${index}.durationHours`)}
                        />
                        {errors?.pricingData && errors?.pricingData[index]?.durationHours && (
                            <p className="text-danger mt-2">
                                {errors?.pricingData[index]?.durationHours?.message}
                            </p>
                        )}
                    </Col>
                )}

                {/* {( pricingType === "day") && (
                    <Col lg="3">
                        <label>{t("roomType.columns.Minimum_stay")}</label>
                        <input
                            type="number"
                            className={`form-control ${isDuplicateValue({
                                pricingData,
                                index,
                                pricingType,
                                fieldName: "minStay",
                            })
                                ? "border-danger"
                                : ""
                                }`}
                            {...register(`pricingData.${index}.minStay`)}
                        />
                    </Col>
                )} */}

                <Col lg="3">
                    <label>{t("roomType.columns.price","Price")} {" "} {pricingType === "day" && "/ Per Day"}</label>
                    <input
                        type="number"
                        className="form-control"
                        {...register(`pricingData.${index}.basePrice`)}
                    />
                    {errors?.pricingData && errors?.pricingData[index]?.basePrice && (
                        <p className="text-danger mt-2">
                            {errors?.pricingData[index]?.basePrice?.message}
                        </p>
                    )}
                </Col>

                {/* <Col lg="3">
                    <label>{t("roomType.columns.discount")} (%)</label>
                    <input
                        type="number"
                        className="form-control"
                        {...register(`pricingData.${index}.discount`)}
                    />
                    {errors?.pricingData && errors?.pricingData[index]?.discount && (
                        <p className="text-danger mt-2">
                            {errors?.pricingData[index]?.discount?.message}
                        </p>
                    )}
                </Col> */}

                {/* <Col lg="3">
                    <label>{t("roomType.columns.final_price")}</label>
                    <input
                        type="number"
                        className="form-control"
                        readOnly
                        {...register(`pricingData.${index}.finalPrice`)}
                    />
                     {errors?.pricingData && errors?.pricingData[index]?.finalPrice && (
                        <p className="text-danger mt-2">
                            {errors?.pricingData[index]?.finalPrice?.message}
                        </p>
                    )}
                </Col> */}

                {canRemove && (
                    <Col lg="12" className="text-end mt-2">
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => remove(index)}
                        >
                            {t("common.remove")}
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    );
};


export default PricingRow;


const isDuplicateValue = ({ pricingData, index, pricingType, fieldName }) => {
    const currentValue = pricingData?.[index]?.[fieldName];

    if (!currentValue) return false;

    return pricingData.some((item, i) => {
        if (i === index) return false;
        if (item.pricingType !== pricingType) return false;
        return String(item[fieldName]) === String(currentValue);
    });
};
